import React from "react";
import { Modal, ModalBody } from "reactstrap";
import styles from "./tagdetail.module.scss";
import Proptypes from "prop-types";

const TagDetailModal = ({
  currentTag,
  openModal,
  toggle,
  getBrandNameById,
  getProductById,
  getLocationById,
}) => {
  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_location_body"]}>
          <div className={styles["tag_header_title"]}>
            <h1>Tag Details</h1>
          </div>

          <div className={styles["_box_wrapper"]}>
            <div className={styles["_single_box"]}>
              <p className={styles["_single_box_title"]}>Brand Name</p>
              <p className={styles["_single_box_info"]}>
                {getBrandNameById(currentTag?.brandId)}
              </p>
            </div>
            <div className={styles["_single_box"]}>
              <p className={styles["_single_box_title"]}>Location</p>
              <p className={styles["_single_box_info"]}>
                {getLocationById(currentTag?.location)}
              </p>
            </div>
          </div>

          <div className={styles["_box_wrapper"]}>
            <div className={styles["_single_box"]}>
              <p className={styles["_single_box_title"]}>Product</p>
              <p className={styles["_single_box_info"]}>
                {getProductById(currentTag?.productId)}
              </p>
            </div>
            <div className={styles["_single_box"]}>
              <p className={styles["_single_box_title"]}>Roll Id</p>
              <p className={styles["_single_box_info"]}>
                {currentTag?.rollId ? currentTag.rollId : "--"}
              </p>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

TagDetailModal.propTypes = {
  currentTag: Proptypes.object,
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
};

export default TagDetailModal;
